import { P } from '@farewill/ui'
import SelectInput from 'components/form/select-input'
import { CASE_STATUSES_OPTIONS } from 'utils/enums'

import BrandFilter from '../shared/brand-filter'
import FilterWrapper from '../shared/filter-wrapper'

const FuneralPlanFilters = (): React.ReactElement => {
  return (
    <>
      <FilterWrapper>
        <P size="S" strong>
          Case status
        </P>
        <SelectInput
          options={CASE_STATUSES_OPTIONS.funeral_plan}
          name="status"
          isMulti
          small
        />
      </FilterWrapper>
      <FilterWrapper>
        <BrandFilter />
      </FilterWrapper>
    </>
  )
}

export default FuneralPlanFilters
